import { render, staticRenderFns } from "./BannerSwiper.vue?vue&type=template&id=6ec6302e&scoped=true"
import script from "./BannerSwiper.vue?vue&type=script&lang=js"
export * from "./BannerSwiper.vue?vue&type=script&lang=js"
import style0 from "./BannerSwiper.vue?vue&type=style&index=0&id=6ec6302e&prod&lang=scss&scoped=true"
import style1 from "./BannerSwiper.vue?vue&type=style&index=1&id=6ec6302e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec6302e",
  null
  
)

export default component.exports